import React, { useState, useEffect } from 'react'
import {
    Avatar,
    Card,
    Result,
    Divider,
    Tooltip,
    InputNumber,
    Calendar,
    Select,
    Form,
    Input,
    Button,
    message
} from 'antd'
import './styles.css'
import imageReservando from './../../images/ic_launcher.png'
import { cloudFunctions, db, storage } from '../../config/Fire'
import * as Constants from '../../constants/nodes_database'
import { Col, Grid, Row } from 'react-flexbox-grid'
import home_icon from '../../images/image_home.png'
import phone_icon from '../../images/image_phone.png'
import facebook_icon from '../../images/image_facebook.png'
import instagram_icon from '../../images/image_instagram.png'
import android_icon from '../../images/android.png'
import apple_icon from '../../images/ios.png'
import logo_reservando_word from '../../images/logo_reservando_word.png'
import LoadingPage from '../LoadingPage'
import { CalendarOutlined, FieldTimeOutlined, UserOutlined } from '@ant-design/icons'
import moment from 'moment'

const { Option } = Select

const RestaurantReserve = () => {
    const [fileListProfile, setFileListProfile] = useState([])
    const [restaurant, setRestaurant] = useState(null)
    const [restaurantError, setRestaurantError] = useState(false)
    const [peopleCountNewReserve, setPeopleCountNewReserve] = useState('1')
    const [dateNewReserve, setDateNewReserve] = useState(moment(new Date()).utcOffset('-0300').format('DD/MM/YYYY'))
    const [hoursAvailableOnDateNewReserve, setHoursAvailableOnDateNewReserve] = useState(null)
    const [hourSelectedOnDateNewReserve, setHourSelectedOnDateNewReserve] = useState(null)
    const [gettingAvailableHoursPerDate, setGettingAvailableHoursPerDate] = useState(false)
    const [reserving, setReserving] = useState(false)

    const [form] = Form.useForm()

    useEffect(() => {
        const location = window.location
        const paths = location.pathname.split('/')
        if (paths[2]) {
            db.ref(`${Constants.RESTAURANTS}/${paths[2]}`).once('value')
                .then((restoSnap) => {
                    if (restoSnap.exists()) {
                        const restaurant = restoSnap.val()
                        if (restaurant && restaurant.logo && restaurant.logo !== '') {
                            const imagesProfile = []
                            storage.ref().child(restaurant.logo).getDownloadURL()
                                .then(url => {
                                    imagesProfile.push({ uid: -1, name: '0', status: 'done', url: url })
                                    setRestaurant(restaurant)
                                    setFileListProfile(imagesProfile)
                                })
                                .catch(err => {
                                    console.log('Storage error: ' + err)
                                    setRestaurant(restaurant)
                                })
                        } else {
                            setRestaurant(restaurant)
                        }
                    } else {
                        console.log('Error getting documents')
                        setRestaurantError(true)
                    }
                })
                .catch(err => {
                    console.log(err)
                    setRestaurantError(true)
                })
        } else {
            setRestaurantError(true)
        }
    }, [])

    const handlePeopleCountNewReserve = value => {
        setPeopleCountNewReserve(value)
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
    }

    const handleDateNewReserve = value => {
        setDateNewReserve(moment(value).format('DD/MM/YYYY'))
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
    }

    const handleHourSelectedOnDateNewReserve = value => {
        setHourSelectedOnDateNewReserve(value)
    }

    const handleCancelNewReserveModal = () => {
        setPeopleCountNewReserve('1')
        setDateNewReserve(moment(new Date()).utcOffset('-0300').format('DD/MM/YYYY'))
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
        setGettingAvailableHoursPerDate(false)
        setReserving(false)
    }

    const handleGetAvailableHoursPerDate = () => {
        setGettingAvailableHoursPerDate(true)
        cloudFunctions.getAvailableHoursPerDate({
            peopleCount: peopleCountNewReserve,
            date: dateNewReserve,
            restoId: restaurant.id
        })
            .then(result => {
                setGettingAvailableHoursPerDate(false)
                if (result && result.data && result.data.code === 0 && result.data.availableHours) {
                    if (result.data.availableHours.length === 0) {
                        message.error('No hay horas disponibles para la fecha seleccionada.')
                        setHoursAvailableOnDateNewReserve(null)
                        setHourSelectedOnDateNewReserve(null)
                    } else {
                        setHoursAvailableOnDateNewReserve(result.data.availableHours)
                        setHourSelectedOnDateNewReserve(result.data.availableHours[0])
                    }
                } else {
                    message.error('No hay horas disponibles para la fecha seleccionada.')
                    setHoursAvailableOnDateNewReserve(null)
                    setHourSelectedOnDateNewReserve(null)
                }
            })
            .catch(err => {
                setGettingAvailableHoursPerDate(false)
                message.error('Se produjo un error al traer las horas. Por favor, refresque la pagina y vuelva a intentar.')
                setHoursAvailableOnDateNewReserve(null)
                setHourSelectedOnDateNewReserve(null)
            })
    }

    const handleTryReserve = () => {
        form.validateFields()
            .then(values => {
                setReserving(true)
                cloudFunctions.tryReserveFromRestaurant({
                    restoId: restaurant.id,
                    date: dateNewReserve,
                    hour: hourSelectedOnDateNewReserve,
                    peopleCount: peopleCountNewReserve,
                    observations: '',
                    platform: 'web',
                    userEmail: values.field_email,
                    userPhone: values.field_phone,
                    userDNI: values.field_dni,
                    userFirstName: values.field_first_name,
                    userLastName: values.field_last_name,
                    userStreet: values.field_street,
                    userCity: values.field_city,
                    userProvince: values.field_province,
                    userCountry: values.field_country
                })
                    .then(result => {
                        setReserving(false)
                        console.log('result: ' + JSON.stringify(result))
                        if (result && result.data && result.data.code === 0 && result.data.reserveState) {
                            switch (result.data.reserveState) {
                                case 'Available':
                                    message.success('La reserva se realizó exitósamente.')
                                    handleCancelNewReserveModal()
                                    break
                                case 'closed':
                                    message.error('El restaurante se encuentra cerrado.')
                                    break
                                case 'restoIncorrectFields':
                                    message.error('Se produjo un error al reservar.')
                                    break
                                case 'notAvailable':
                                    if (result.data.reason) {
                                        switch (result.data.reason) {
                                            case 'placesNotAvailable':
                                                message.error('No hay lugares disponibles.')
                                                break
                                            case 'minimumPreviousReservationHours':
                                                const errorMinimum = `La reserva debe realizarse con un mínimo de ${result.data.minimumPreviousReservationHours ? result.data.minimumPreviousReservationHours : 'NUMBER'} horas de anticipación.`
                                                message.error(errorMinimum)
                                                break
                                            case 'maximumPreviousReservationDays':
                                                const errorMaximum = `No es posible realizar una reserva con anticipación máxima a ${result.data.maximumPreviousReservationDays ? result.data.maximumPreviousReservationDays : 'NUMBER'} días.`
                                                message.error(errorMaximum)
                                                break
                                            default:
                                                break
                                        }
                                    } else {
                                        message.error('No es posible realizar una reserva con las configuraciones seleccionadas.')
                                    }
                                    break
                                default:
                                    message.error('Se produjo un error al reservar.')
                                    break
                            }
                        } else {
                            message.error('Se produjo un error al reservar. Por favor, refresque la página y vuelva a intentar.')
                        }
                    })
                    .catch(err => {
                        setReserving(false)
                        message.error('Se produjo un error al reservar. Por favor, refresque la página y vuelva a intentar.')
                    })
            })
            .catch(() => {
            })
    }

    return (
        <div>
            {
                restaurantError ?
                    <Result
                        status="404"
                        title="404"
                        subTitle="Lo siento, el restaurante no existe."
                    />
                    :
                    restaurant ?
                        <div className="restaurantReserveCont">
                            <Grid className="gridCont">
                                <Row center="md">
                                    <Col xs={12} sm={12} md={8}>
                                        <Card
                                            style={{ borderRadius: '6px' }}
                                            headStyle={{
                                                backgroundColor: 'rgb(242, 242, 242)',
                                                border: 0,
                                                borderRadius: '6px 6px 0 0'
                                            }}
                                            bodyStyle={{ borderRadius: '0 0 6px 6px' }}
                                            title={
                                                <Grid className="titleCardCont">
                                                    <Row center="xs">
                                                        <Col xs={12} sm={8} md={8} lg={6} xl={6}>
                                                            <img style={{ width: '80%' }} src={logo_reservando_word}
                                                                 alt="Reservando"/>
                                                        </Col>
                                                    </Row>
                                                    <Row center="xs">
                                                        <Col xs={12}>
                                                            <Avatar size={70}
                                                                    src={fileListProfile.length > 0 ? fileListProfile[0].url : imageReservando}/><br/>
                                                            <h2>{restaurant.name}</h2>
                                                        </Col>
                                                    </Row>
                                                    <Row center="xs">
                                                        <Col xs={2}>
                                                            {
                                                                restaurant.address && restaurant.address.street !== '' ?
                                                                    <Tooltip
                                                                        title={`${restaurant.address.street} (${restaurant.address.city},
                                                            CP ${restaurant.address.postalCodeV2})`}>
                                                                        {
                                                                            restaurant.l && restaurant.l.length === 2 && restaurant.l[0] !== '' && restaurant.l[1] !== '' ?
                                                                                <a href={`http://maps.google.com/maps?q=${restaurant.l[0]},${restaurant.l[1]}`}
                                                                                   target="_blank"
                                                                                   rel="noopener noreferrer"><Avatar
                                                                                    size="large" src={home_icon}/></a>
                                                                                :
                                                                                <Avatar
                                                                                    size="large" src={home_icon}/>
                                                                        }
                                                                    </Tooltip>
                                                                    :
                                                                    <Avatar
                                                                        size="large" src={home_icon}/>
                                                            }
                                                        </Col>
                                                        <Col xs={2}>
                                                            {
                                                                restaurant.phone && restaurant.phone !== '' ?
                                                                    <Tooltip title={`${restaurant.phone}`}>
                                                                        <a href={`tel:${restaurant.phone}`}
                                                                           target="_blank"
                                                                           rel="noopener noreferrer"><Avatar
                                                                            size="large"
                                                                            src={phone_icon}/></a>
                                                                    </Tooltip>
                                                                    :
                                                                    <Avatar size="large"
                                                                            src={phone_icon}/>
                                                            }
                                                        </Col>
                                                        <Col xs={2}>
                                                            {
                                                                restaurant.facebook && restaurant.facebook !== '' ?
                                                                    <a href={restaurant.facebook} target="_blank"
                                                                       rel="noopener noreferrer"><Avatar size="large"
                                                                                                         src={facebook_icon}/></a>
                                                                    :
                                                                    <Avatar size="large"
                                                                            src={facebook_icon}/>
                                                            }
                                                        </Col>
                                                        <Col xs={2}>
                                                            {
                                                                restaurant.instagram && restaurant.instagram !== '' ?
                                                                    <a href={restaurant.instagram} target="_blank"
                                                                       rel="noopener noreferrer"><Avatar size="large"
                                                                                                         src={instagram_icon}/></a>
                                                                    :
                                                                    <Avatar size="large"
                                                                            src={instagram_icon}/>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Grid>
                                            }>
                                            <Grid>
                                                <Row center="xs">
                                                    <Col xs={12}>
                                                        <h1 style={{ marginBottom: 0 }}>Nueva Reserva</h1>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><UserOutlined style={{ color: '#94509b' }}/> Personas</h2>
                            </span>
                                                    </Col>
                                                </Row>
                                                <Row center="xs">
                                                    <Col xs={12}>
                                                        <InputNumber
                                                            min={1}
                                                            max={5}
                                                            step={'1'}
                                                            onChange={handlePeopleCountNewReserve}
                                                            value={peopleCountNewReserve !== null ? peopleCountNewReserve : 1}/>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><CalendarOutlined style={{ color: '#94509b' }}/> Fecha</h2>
                            </span>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Calendar
                                                            className="CalendarCont"
                                                            format={'DD/MM/YYYY'}
                                                            defaultValue={moment(dateNewReserve, 'DD/MM/YYYY')}
                                                            onSelect={(date) => handleDateNewReserve(date)}
                                                            fullscreen={false}
                                                            disabledDate={(current) => {
                                                                let customDate = moment(new Date()).utcOffset('-0300').format('YYYY-MM-DD')
                                                                return current && current < moment(customDate, 'YYYY-MM-DD')
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><FieldTimeOutlined style={{ color: '#94509b' }}/> Hora</h2>
                            </span>
                                                    </Col>
                                                </Row>
                                                <Row center="xs">
                                                    <Col xs={12}>
                                                        <Select className="selectHourOnDateNewReserve"
                                                                onChange={handleHourSelectedOnDateNewReserve}
                                                                value={hourSelectedOnDateNewReserve}>
                                                            {
                                                                hoursAvailableOnDateNewReserve !== null &&
                                                                hoursAvailableOnDateNewReserve.map(hour => <Option
                                                                    key={hour}>{hour}</Option>)
                                                            }
                                                        </Select>
                                                    </Col>
                                                </Row>
                                                <Row className="rowInfoNewReserveCont" center="xs">
                                                    <Col xs={4} className="infoNewReserveCont">
                                                        <h3 style={{ margin: '6px 0' }}>Mesa
                                                            para {peopleCountNewReserve}</h3>
                                                    </Col>
                                                    <Col xs={4} className="infoNewReserveCont">
                                                        <h3 style={{ margin: '6px 0' }}>{moment(dateNewReserve, 'DD/MM/YYYY').format('DD/MM/YYYY')}</h3>
                                                    </Col>
                                                    <Col xs={4} className="infoNewReserveCont">
                                                        <h3 style={{ margin: '6px 0' }}>{hourSelectedOnDateNewReserve !== null ? `${hourSelectedOnDateNewReserve} h` : ''}</h3>
                                                    </Col>
                                                </Row>
                                                {
                                                    hourSelectedOnDateNewReserve &&
                                                    <Form form={form} initialValues={{
                                                        field_city: restaurant.address && restaurant.address.city ? restaurant.address.city : undefined,
                                                        field_province: restaurant.address && restaurant.address.province ? restaurant.address.province : undefined,
                                                        field_country: restaurant.address && restaurant.address.country ? restaurant.address.country : undefined
                                                    }}>
                                                        <Row>
                                                            <Col xs={12} sm={6} className="formItemXSBottom">
                                                                <Form.Item name="field_first_name" rules={[{
                                                                    required: true,
                                                                    message: 'Por favor, ingrese su/s nombre/s'
                                                                }]}>
                                                                    <Input placeholder="Nombre/s"/>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={12} sm={6}>
                                                                <Form.Item name="field_last_name" rules={[{
                                                                    required: true,
                                                                    message: 'Por favor, ingrese su/s apellido/s'
                                                                }]}>
                                                                    <Input placeholder="Apellido/s"/>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={12} sm={6} className="formItemXSBottom">
                                                                <Form.Item name="field_dni" rules={[{
                                                                    required: true,
                                                                    message: 'Por favor, ingrese su DNI'
                                                                }]}>
                                                                    <Input type="number" placeholder="dni"/>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={12} sm={6}>
                                                                <Form.Item name="field_email" rules={[{
                                                                    type: 'email',
                                                                    message: 'El correo no es válido'
                                                                }, {
                                                                    required: true,
                                                                    message: 'Por favor, ingrese su correo electrónico'
                                                                }]}>
                                                                    <Input placeholder="Correo electrónico"/>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={12} sm={6} className="formItemXSBottom">
                                                                <Form.Item name="field_phone" rules={[{
                                                                    required: false,
                                                                    message: 'Por favor, ingrese su teléfono'
                                                                }]}>
                                                                    <Input type="number" placeholder="Teléfono"/>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={12} sm={6}>
                                                                <Form.Item name="field_street" rules={[{
                                                                    required: false,
                                                                    message: 'Por favor, ingrese su dirección'
                                                                }]}>
                                                                    <Input placeholder="Dirección"/>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={12} sm={6} className="formItemXSBottom">
                                                                <Form.Item name="field_city" rules={[{
                                                                    required: false,
                                                                    message: 'Por favor, ingrese su ciudad'
                                                                }]}>
                                                                    <Input placeholder="Ciudad"/>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={12} sm={6}>
                                                                <Form.Item name="field_province" rules={[{
                                                                    required: false,
                                                                    message: 'Por favor, ingrese su provincia'
                                                                }]}>
                                                                    <Input placeholder="Provincia"/>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={12} sm={6}>
                                                                <Form.Item name="field_country" rules={[{
                                                                    required: false,
                                                                    message: 'Por favor, ingrese su país'
                                                                }]}>
                                                                    <Input placeholder="País"/>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                }
                                                <Row>
                                                    <Col xs={12}>
                                                        {
                                                            hoursAvailableOnDateNewReserve ?
                                                                <Button className="buttonTryReserve"
                                                                        onClick={handleTryReserve}
                                                                        disabled={hourSelectedOnDateNewReserve === null}
                                                                        loading={reserving}>RESERVAR</Button>
                                                                :
                                                                <Button className="buttonGetAvailableHoursPerDate"
                                                                        onClick={handleGetAvailableHoursPerDate}
                                                                        loading={gettingAvailableHoursPerDate}>CONSULTAR
                                                                    DISPONIBILIDAD</Button>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Divider/>
                                                <Row>
                                                    <Col xs={5}>
                                                        <Row end="xs">
                                                            <Col xs={12}>
                                                                <a href="https://play.google.com/store/apps/details?id=com.reservando.android"
                                                                   target="_blank" rel="noopener noreferrer"><Avatar
                                                                    size="large" src={android_icon}/></a>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={2}/>
                                                    <Col xs={5}>
                                                        <Row start="xs">
                                                            <Col xs={12}>
                                                                <a href="https://apps.apple.com/us/app/reservando/id1454333767?l=es&ls=1"
                                                                   target="_blank" rel="noopener noreferrer"><Avatar
                                                                    size="large" src={apple_icon}/></a>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </Card>
                                    </Col>
                                </Row>
                            </Grid>
                        </div>
                        :
                        <LoadingPage/>
            }
        </div>
    )
}

export default RestaurantReserve